import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { EmptyState } from '@experiences/components/empty-state';
import { useTheme } from '@/contexts/theme-context';

interface OrderEntrySearchEmptyStateProps {
  onSearchCatalog?: () => void;
  searchTerm: string;
}

export const OrderEntrySearchEmptyState: React.FC<
  OrderEntrySearchEmptyStateProps
> = ({ onSearchCatalog, searchTerm }) => {
  const theme = useTheme();

  return (
    <EmptyState
      bottomElement={
        onSearchCatalog ? (
          <Button
            accessibilityLabel={i18n.t(
              'sales_portal.order_entry.empty.search_catalog',
            )}
            onPress={onSearchCatalog}
            size={ButtonSize.Medium}
            variant={ButtonVariant.Secondary}
            width={132}
          >
            {i18n.t('sales_portal.order_entry.empty.search_catalog')}
          </Button>
        ) : undefined
      }
      description={i18n.t('sales_portal.order_entry.empty.search.description')}
      iconElement={
        <EmptyDottedIcon
          fill={theme.sk.color.icon.primary}
          height={48}
          width={48}
        />
      }
      title={i18n.t('sales_portal.order_entry.empty.search.title', {
        searchTerm,
      })}
    />
  );
};
